import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';
import store from './Redux/Store';
import { Provider } from "react-redux";
import { DeviceProvider } from './context/DeviceContext'
const root = ReactDOM.createRoot(document.getElementById('root'));
const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

root.render(
  <>
    {clientId ? (
      <GoogleOAuthProvider clientId={clientId}>
        <Provider store={store}>
          <DeviceProvider>
            <App />
          </DeviceProvider>
        </Provider>
      </GoogleOAuthProvider>
    ) : (
      <Provider store={store}>
        <DeviceProvider>
          <App />
        </DeviceProvider>
      </Provider>
    )}
  </>
);



